import { render, staticRenderFns } from "./passengerFlowTrend.vue?vue&type=template&id=0d80d8d2&scoped=true&"
import script from "./passengerFlowTrend.vue?vue&type=script&lang=js&"
export * from "./passengerFlowTrend.vue?vue&type=script&lang=js&"
import style0 from "./passengerFlowTrend.vue?vue&type=style&index=0&id=0d80d8d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80d8d2",
  null
  
)

export default component.exports